<div class="dropdown dropdown-end w-full group">
  <div
    tabindex="0"
    role="button"
    class="flex min-h-0 w-full cursor-pointer items-center gap-2 rounded-full bg-base-200/80 px-3 py-2 transition-colors hover:bg-base-300"
  >
    <lucide-icon
      [name]="ROLE_ICONS[activeRole()]"
      class="h-4 w-4 shrink-0 stroke-current text-base-content/70"
    />
    <span class="min-w-0 flex-1 truncate text-sm font-medium">{{ ROLE_LABELS[activeRole()] }}</span>
    <lucide-icon
      name="chevron-down"
      class="h-4 w-4 shrink-0 transition-transform duration-200 group-focus-within:rotate-180"
    />
  </div>
  <ul
    tabindex="-1"
    class="dropdown-content menu z-10 mt-1 w-full rounded-box bg-base-200 p-1 shadow"
  >
    @for (role of switchableRoles(); track role) {
      <li>
        <button
          type="button"
          class="flex w-full items-center gap-2 rounded-lg hover:bg-base-300"
          [class.bg-primary/10]="activeRole() === role"
          [class.text-primary]="activeRole() === role"
          (click)="selectRole(role)"
        >
          <lucide-icon
            [name]="ROLE_ICONS[role]"
            class="h-4 w-4 shrink-0 stroke-current"
          />
          <span class="flex-1 text-left">{{ ROLE_LABELS[role] }}</span>
          @if (activeRole() === role) {
            <lucide-icon name="check" class="h-4 w-4 shrink-0 stroke-current" />
          }
        </button>
      </li>
    }
  </ul>
</div>
